import React from 'react';

import { IItem } from 'api/catalog/models';
import NoInformationAvailable from 'ui/ErrorDisplay/NoInformationAvailable';

interface IProps {
  item?: IItem;
}

const ItemAttributes = ({ item }: IProps) => {
  if (item?.itemAttributes && item.itemAttributes.length > 0) {
    return (
      <ul>
        {item.itemAttributes.map((attr) => (
          <li key={attr}>{attr}</li>
        ))}
      </ul>
    );
  } else {
    return <NoInformationAvailable minHeight='300px' />;
  }
};

export default ItemAttributes;
